import { startAuthentication } from '@simplewebauthn/browser'

import { api } from '../api.js'
import { prfAnfordern, prfAuslesen } from './prf.js'

/**
 * Holt vom Passkey das Geheimnis, mit dem sich der Schlüsselspeicher öffnen
 * lässt — ohne neue Anmeldung, mit bestehender Sitzung.
 *
 * Der Rückgabewert ist `null`, wenn die Zeremonie geklappt hat, der
 * Authenticator aber kein PRF liefert. Das ist kein Fehler, sondern eine
 * Eigenschaft des Geräts: Dann bleibt der Satz der Weg.
 *
 * ## Warum der Server überhaupt gefragt wird
 *
 * Das Geheimnis kommt aus dem Authenticator und verlässt den Browser nie — für
 * das Entsperren allein bräuchte es keinen Server. Die Challenge von dort macht
 * die Zeremonie aber überhaupt erst prüfbar: Ohne sie liefe der Zähler gegen
 * geklonte Authenticator nie mit, und im Protokoll stünde nicht, wann jemand
 * den Schlüsselspeicher geöffnet hat.
 */
export async function passkeyGeheimnis(): Promise<ArrayBuffer | null> {
  const options = await api.post<Parameters<typeof startAuthentication>[0]['optionsJSON']>(
    '/auth/webauthn/unlock/options',
  )
  const response = await startAuthentication({
    optionsJSON: { ...options, extensions: prfAnfordern() },
  })
  await api.post('/auth/webauthn/unlock/verify', { response })
  return prfAuslesen(response.clientExtensionResults)
}

/** Kann dieser Browser überhaupt Passkeys? Alte Geräte können es nicht. */
export function passkeysMoeglich(): boolean {
  return typeof PublicKeyCredential !== 'undefined'
}
